import { NgIf } from '@angular/common';
import { Injectable } from '@angular/core';
import { Http, Headers, ResponseContentType } from '@angular/http';
import { isObject } from 'lodash';
import 'rxjs/add/operator/delay';
import { ioExtend } from './io-Extend';
import { QueryParams } from './io-Utilities';
@Injectable()
export class appHttpClient {
    requestDelay = 0;

    constructor (private _http: Http) { }

    private setAuthorizationHeader(headers: Headers) {
        headers.append('AuthToken', localStorage.getItem('AuthToken'));
        headers.append('AuthSalt', localStorage.getItem('AuthSalt'));
    }

    public Get(url, _defaultHeader = true, _responseType: ResponseContentType = null) {
        const _options: {
            headers?: Headers
            , responseType?: ResponseContentType
        } = {};
        const _headers = new Headers();

        if (_defaultHeader) {
            this.setAuthorizationHeader(_headers);
            _options.headers = _headers
        }

        if (_responseType) {
            _options.responseType = _responseType;
        }
        return this._http.get(url, _options)
            .delay(this.requestDelay);
    }

    public Post(url, data: string, _contentType = 'application/json', _responseType: ResponseContentType = null) {
        const _options: {
            headers?: Headers
            , responseType?: ResponseContentType
        } = {};
        const _headers = new Headers();

        _headers.append('Content-Type', _contentType);
        if (_responseType) {
            _options.responseType = _responseType;
        }
        this.setAuthorizationHeader(_headers);

        _options.headers = _headers;

        return this._http.post(url, data, _options).delay(this.requestDelay);
    }

    public Put(url, data: string, _contentType = 'application/json') {
        const _headers = new Headers();
        _headers.append('Content-Type', _contentType);
        this.setAuthorizationHeader(_headers);
        return this._http.put(url, data, {
            headers: _headers
        }).delay(this.requestDelay);
    }

    public Delete(url) {
        const _headers = new Headers();
        this.setAuthorizationHeader(_headers);
        return this._http.delete(url, {
            headers: _headers
        }).delay(this.requestDelay);
    }

    // public Upload(url: string, files: File[], _method: 'POST' | 'PUT' = 'POST'): Promise<any> {
    //     return new Promise((resolve, reject) => {
    //         const formData: FormData = new FormData(),
    //             xhr: XMLHttpRequest = new XMLHttpRequest();

    //         for (let i = 0; i < files.length; i++) {
    //             formData.append('uploads[]', files[i], files[i].name);
    //         }

    //         xhr.onreadystatechange = () => {
    //             if (xhr.readyState === 4) {
    //                 if (xhr.status === 200) {
    //                     resolve(JSON.parse(xhr.response));
    //                 } else {
    //                     reject(xhr.response);
    //                 }
    //             }
    //         };

    //         xhr.open(_method, url, true);
    //         xhr.setRequestHeader('Authorization', localStorage.getItem('AuthToken'));
    //         xhr.send(formData);
    //     });
    // }

    public Upload(url: string, data: {}, files: File[] = [], _method: 'POST' | 'PUT' = 'POST'): Promise<any> {
        return new Promise((resolve, reject) => {
            const xhr: XMLHttpRequest = new XMLHttpRequest();
            let formData: FormData = new FormData();

            for (let i = 0; i < files.length; i++) {
                formData.append('Attachments', files[i], files[i].name);
            }
            formData = this.JSONtoFormData(formData, data);

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };

            xhr.open(_method, url, true);
            xhr.setRequestHeader('Authorization', localStorage.getItem('AuthToken'));
            xhr.send(formData);
        });
    }

    public Upload2(url: string, data: {}, files: File[] = [], _method: 'POST' | 'PUT' = 'POST'): Promise<any> {
        return new Promise((resolve, reject) => {
            const xhr: XMLHttpRequest = new XMLHttpRequest();
            let formData: FormData = new FormData();

            for (let i = 0; i < files.length; i++) {
                formData.append('Attachments', files[i], files[i].name);
            }
            formData = this.convertModelToFormData(data, formData);

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };

            xhr.open(_method, url, true);
            xhr.setRequestHeader('Authorization', localStorage.getItem('AuthToken'));
            xhr.send(formData);
        });
    }

    public XMLResponseToJSON(_res) {
        const _parser = new DOMParser();
        const _xmlDoc = _parser.parseFromString(_res.text(), 'text/xml');
        const _resText = (<any>_xmlDoc.childNodes.item(0)).innerHTML;
        return JSON.parse(_resText);
    };


    private JSONtoFormData(formData: FormData, data: {}, nestedName: string = null) {
        for (const prop in data) {
            const c = data[prop];
            if (!(data[prop] instanceof File || data[prop] instanceof Array)) {
                if (isObject(data[prop])) {
                    this.JSONtoFormData(formData, data[prop], prop)
                } else {
                    if (nestedName) {
                        formData.append(`${nestedName}[${prop}]`, data[prop])
                    } else {
                        formData.append(prop, data[prop]);
                    }

                }
            }

        }
        return formData;
    }

    private convertModelToFormData(model: any, form: FormData = null, namespace = ''): FormData {
        let formData = form || new FormData();
        for (let propertyName in model) {
            if (!model.hasOwnProperty(propertyName) || !model[propertyName]) continue;
            let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;
            if (model[propertyName] instanceof Date)
                formData.append(formKey, model[propertyName].toISOString());
            else if (model[propertyName] instanceof Array) {
                model[propertyName].forEach((element, index) => {
                    const tempFormKey = `${formKey}[${index}]`;
                    this.convertModelToFormData(element, formData, tempFormKey);
                });
            }
            else if (typeof model[propertyName] === 'object' && !(model[propertyName] instanceof File))
                this.convertModelToFormData(model[propertyName], formData, formKey);
            else
                formData.append(formKey, model[propertyName].toString());
        }
        return formData;
    }
}


export interface ioRequestAggregateModel<T> {
    field: keyof T;
    aggregate: 'sum' | 'count' | 'avg';
}

export interface ioRequestSortModel<T> {
    field: keyof T;
    sort: 'asc' | 'desc';
}

export class ioRequestGetModel<T> {
    fields: (keyof T)[] = [];
    aggregate: ioRequestAggregateModel<T>[] = [];
    extras: string[] = []; //extra fields    
    includes: string[] = []; //join tables
    filter: Partial<T> = {};
    sort: ioRequestSortModel<T>[] = [];
    limit: number = -1;
    offset: number = -1;

    toJSONData() {
        return JSON.stringify(this);
    }

    toQueryParamData() {
        return QueryParams.stringify(this);
    }

    constructor(_clazz){
        ioExtend(this, _clazz);
    }

}
